export enum TipoMatrimonioUnionCivil
{
    SeparadoDeBienes = "Separado de Bienes",
    SociedadConyugal = "Sociedad Conyugal",
    ParticipacionEnLosGananciales = "Participación en los Gananciales",
    ComunidadDeBienes = "Comunidad de Bienes",
}